import { Dispatch } from 'react'
import {
  LOAD_REPORT_DETAILS_ERROR,
  LOAD_REPORT_DETAILS_RECEIVED,
  LOAD_REPORT_DETAILS_REQUEST,
  LOAD_REPORT_HTML_ERROR,
  LOAD_REPORT_HTML_RECEIVED,
  LOAD_REPORT_HTML_REQUEST,
  LOAD_REPORTS_ERROR,
  LOAD_REPORTS_RECEIVED,
  LOAD_REPORTS_REQUEST,
  SET_REPORT_PARAMS,
  ReportsAction
} from './reducers'

import * as api from '../services/api'
import { AppState } from '../../../global/store'
import { createResponseArrayTransformer } from '../../../global/services/transformer'
import { ActionError } from '../../../global/errors'
import { Report, ReportParam } from './store'
import moment from 'moment'

const reportArrayTransformer = createResponseArrayTransformer("reports")

export function loadReports() {
  return async function (state: AppState, dispatch: Dispatch<ReportsAction>) {
    try {
      dispatch({
        type: LOAD_REPORTS_REQUEST
      })

      const reports = reportArrayTransformer(await api.getReports())

      dispatch({
        type: LOAD_REPORTS_RECEIVED,
        reports: reports
      })
    } catch (error) {      
      throw new ActionError(LOAD_REPORTS_ERROR, error)
    }
  }
}

export function loadReport(partnerId: string) {
  return async function (state: AppState, dispatch: Dispatch<ReportsAction>) {
    try {
      dispatch({
        type: LOAD_REPORT_DETAILS_REQUEST
      })

      const reportDetails = await api.getReport(partnerId)

      if (reportDetails.data.params) {
        reportDetails.data.params.forEach((p: ReportParam) => {
          if (p.value === undefined) {
            p.value = ''
          } else if (p.type === "date") {
            p.value = moment(p.value).toDate()
          }
        })
      }

      dispatch({
        type: LOAD_REPORT_DETAILS_RECEIVED,
        report: reportDetails.data
      })
    } catch (error) {
      throw new ActionError(LOAD_REPORT_DETAILS_ERROR, error)
    }
  }
}

export function updateParams(params: ReportParam[]) {
  return async function (state: AppState, dispatch: Dispatch<ReportsAction>) {
    try {
      dispatch({
        type: SET_REPORT_PARAMS,
        params
      })

    } catch (error) {
      dispatch({
        type: LOAD_REPORT_HTML_ERROR
      })
    }
  }
}

export function runReport(partnerId: string, report: Report) {
  return async function (state: AppState, dispatch: Dispatch<ReportsAction>) {
    try {
      const { id, params } = report

      dispatch({
        type: LOAD_REPORT_HTML_REQUEST
      })

      const reportHTML = await api.getReportHTML(partnerId, id, params)

      dispatch({
        type: LOAD_REPORT_HTML_RECEIVED,
        report: reportHTML
      })
    } catch (error) {
      throw new ActionError(LOAD_REPORT_HTML_ERROR, error) 
    }
  }
}
